import React, { SetStateAction } from 'react'
import { Col, ProfileLocation, Row } from 'react-angle-dashboard-components'
import { useProviderProfile } from './context'
import { LayoutContainer } from './LayoutContainer'

export interface IFacilityLocationSectionProps {
  selectedLocationIndex: number
  setSelectedLocationIndex: React.Dispatch<SetStateAction<number>>
}
export const FacilityLocationSection: React.FC<
  IFacilityLocationSectionProps
> = ({ selectedLocationIndex, setSelectedLocationIndex }) => {
  const { googleApiKey } = (window as any).runtimeConfig
  const { mapLocations } = useProviderProfile()

  const messages = {
    facilityLocation: {
      title: 'Office locations'
    },
    about: {
      title: 'About'
    },
    header: {
      inNetwork: 'In-network',
      outOfNetwork: 'Out-of-network',
      seeAProblem: 'See a problem?',
      suggest: 'Suggest an edit'
    }
  }

  return (
    <section className="pt-4 container-fluid">
      <LayoutContainer>
        <strong>
          {messages.facilityLocation.title} ({mapLocations?.length})
        </strong>
        <Row className="my-3">
          <Col md="8">
            <ProfileLocation
              zoom={15}
              apiKey={googleApiKey}
              locations={mapLocations}
              selectedLocationIndex={selectedLocationIndex}
              setSelectedLocationIndex={setSelectedLocationIndex}
            />
          </Col>
        </Row>
      </LayoutContainer>
    </section>
  )
}
